module.exports = __webpack_public_path__ + "img/wisdom.06216fcd.svg";